export default function LogoMark() {
  return (
    <svg
      className="logo-mark"
      viewBox="0 0 96 132"
      role="img"
      aria-labelledby="logo-title"
      focusable="false"
    >
      <title id="logo-title">Gospel Keys Made Simple</title>
      <rect x="3" y="7" width="90" height="120" rx="4" fill="#f8fafc" />
      <rect x="3" y="7" width="90" height="120" rx="4" fill="none" stroke="#050505" strokeWidth="2.5" />
      <rect x="2" y="4" width="92" height="7" fill="#f10f0f" />

      <path d="M24 8V127M48 8V127M72 8V127" stroke="#050505" strokeWidth="2.5" />

      <rect x="14" y="8" width="18" height="84" rx="2.5" fill="#020202" />
      <rect x="38" y="8" width="20" height="84" rx="2.5" fill="#020202" />
      <rect x="64" y="8" width="18" height="84" rx="2.5" fill="#020202" />
    </svg>
  );
}
